export default "__VITE_ASSET__riUUVRnZ__"